import React, { Component } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import Phone from '../components/Phonenumber';
import ResponseModal from './ResponseModal';
import closeIcon from '../pages/images/close-icon.svg';

import './hero.css';
import { CAPTCHA_SITE_KEY } from './apply/constant';

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.checkClick = this.checkClick.bind(this);
    this.checkESC = this.checkESC.bind(this);
  }
  checkESC(event) {
    // Check if ESC key is pressed
    if (event.which === 27) {
      this.props.onClose();
    }
  }
  checkClick(event) {
    // Check if the target is modal
    if (this.modalRef === event.target) {
      this.props.onClose();
    }
  }
  render() {
    if (this.props.show) {
      return (
        <div
          className="modal-container"
          id="modal"
          ref={(node) => {
            this.modalRef = node;
          }}
          onKeyDown={this.checkESC}
          onClick={this.checkClick}
          tabIndex={0}
          role="button"
        >
          <div className="modal">
            <img
              src={closeIcon}
              className="close-modal"
              onClick={this.props.onClose}
              width="11"
              alt="X"
              loading="lazy"
            />
            {this.props.children}
          </div>
        </div>
      );
    }
    return null;
  }
}

class Form extends Component {
  constructor(props) {
    super();
    this.state = {
      status: 'IDLE', // Can be anything from ['IDLE' ,'SUBMITTING', 'FAILED', 'SUBMITTED']
      name: '',
      email: '',
      phone: '',
    };
    this.submitForm = this.submitForm.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCaptcha = this.handleCaptcha.bind(this);
  }
  submitForm(e) {
    e.preventDefault();
    this.setState({
      status: 'SUBMITTING',
    });
    let formData = new FormData();
    formData.append('name', this.state.name);
    formData.append('email', this.state.email);
    formData.append('phone', this.state.phone);
    formData.append('captcha', this.state.captcha);
    let url = 'http://internal.staging.zopsmart.com/mail.php';
    if (window.location.host === 'www.zopsmart.com') {
      url = 'https://internal.zopsmart.com/mail.php';
    }
    let headers = new Headers({
      Authorization: 'Basic YWRtaW46ZzBAbFAwJHQ=',
    });
    window
      .fetch(url, {
        method: 'POST',
        headers: headers,
        body: formData,
      })
      .catch((error) => {
        this.setState({
          status: 'FAILED',
        });
        console.error(error);
      })
      .then((response) => {
        if (response.ok) {
          this.setState({
            status: 'SUBMITTED',
          });
        } else {
          this.setState({
            status: 'FAILED',
          });
        }
      });
  }

  handleCaptcha(value) {
    this.setState({
      captcha: value,
    });
  }

  handleChange(event) {
    if (typeof event === 'object') {
      this.setState({
        [event.target.name]: event.target.value.trim(),
      });
    } else if (typeof event === 'string') {
      this.setState({ phone: event });
    } else if (!event) {
      this.setState({ phone: '' });
    }
  }
  render() {
    const contactForm = (
      <div>
        <div className="tc">
          <h2>Get a product demo</h2>
          <p>
            Please fill in your details and we will fix up a product demo at your earliest
            convenience.
          </p>
          <hr />
        </div>
        <form onSubmit={this.submitForm} method="POST" id="contact-form">
          {this.state.status === 'FAILED' && (
            <p className="error">
              Oops! Form submission failed. Please email your queries to{' '}
              <a href="mailto:info@zopsmart.com">info@zopsmart.com</a>
            </p>
          )}
          <div className="label" aria-label="name">
            NAME
          </div>
          <input
            aria-label="name"
            name="name"
            id="demo-form-name"
            placeholder="Enter your name"
            onChange={this.handleChange}
            value={this.state.name}
            required
          />
          <div className="label" aria-label="email-address">
            EMAIL ADDRESS
          </div>
          <input
            aria-label="email"
            name="email"
            id="demo-from-email"
            placeholder="Enter your email"
            type="email"
            onChange={this.handleChange}
            value={this.state.email}
            required
          />
          <div className="label">PHONE NUMBER</div>
          {/* <input name='phone' id='demo-form-phone' placeholder='Enter your phone number' type='tel' required /> */}
          <Phone
            onChange={this.handleChange}
            value={this.state.phone /* ignoring the country code in the input field */}
          />
          <ReCAPTCHA
            sitekey={CAPTCHA_SITE_KEY}
            theme="light"
            className="captcha-enterprise"
            onChange={this.handleCaptcha}
            ref={(el) => {
              this.captcha = el;
            }}
            onExpired={() => this.setState({ captcha: '' })}
          />
          <input
            aria-label="submit"
            className="cta-link"
            type="submit"
            value={this.state.status === 'SUBMITTING' ? 'submitting...' : 'submit'}
            disabled={!this.state.captcha || this.state.status === 'SUBMITTING'}
          />
        </form>
      </div>
    );
    const successMessage = <ResponseModal onClose={this.props.onClose} />;
    return this.state.status === 'SUBMITTED' ? successMessage : contactForm;
  }
}

class Demo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
  }
  render() {
    return (
      <div>
        <a
          className="cta-link"
          href="/"
          onClick={(e) => {
            e.preventDefault();
            this.setState({
              showModal: true,
            });
          }}
        >
          get a demo
        </a>
        <Modal
          show={this.state.showModal}
          onClose={(e) => {
            this.setState({
              showModal: false,
            });
          }}
        >
          <Form
            onClose={(e) => {
              this.setState({
                showModal: false,
              });
            }}
          />
        </Modal>
      </div>
    );
  }
}

const EnterpriseDemo = (props) => (
  <Modal show={props.showModal} onClose={props.onClose}>
    <Form onClose={props.onClose} />
  </Modal>
);
export default ({ scrollTo }) => (
  <div className="hero hero-eazy">
    <div className="wrap tc">
      <h1>SmartStore Eazy</h1>
      <p>The ultimate E-commerce Platform for Entrepreneurs</p>
      <ul className="easy-features">
        <li>Get your own international quality e-commerce website quickly</li>
        <li>Keep complete control using simple admin module</li>
        <li>Send marketing communications to your customers</li>
      </ul>
      <Demo />
    </div>
  </div>
);

export { Modal, EnterpriseDemo };
